(($) => {

    'use strict';


    const handleValidation = function () {

        let formvalidator = jQuery('.form-validate');
        if (formvalidator.length === 0) {
            return;
        }

        $.extend($.validator.messages, {
            required: "Ce champ est obligatoire.",
            remote: "Veuillez corriger ce champ.",
            email: "Veuillez fournir une adresse électronique valide.",
            url: "Veuillez fournir une adresse URL valide.",
            date: "Veuillez fournir une date valide.",
            dateISO: "Veuillez fournir une date valide (ISO).",
            number: "Veuillez fournir un numéro valide.",
            digits: "Veuillez fournir seulement des chiffres.",
            creditcard: "Veuillez fournir un numéro de carte de crédit valide.",
            equalTo: "Veuillez fournir encore la même valeur.",
            notEqualTo: "Veuillez fournir une valeur différente, les valeurs ne doivent pas être identiques.",
            extension: "Veuillez fournir une valeur avec une extension valide.",
            maxlength: $.validator.format("Veuillez fournir au plus {0} caractères."),
            minlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
            rangelength: $.validator.format("Veuillez fournir une valeur qui contient entre {0} et {1} caractères."),
            range: $.validator.format("Veuillez fournir une valeur entre {0} et {1}."),
            max: $.validator.format("Veuillez fournir une valeur inférieure ou égale à {0}."),
            min: $.validator.format("Veuillez fournir une valeur supérieure ou égale à {0}."),
            step: $.validator.format("Veuillez fournir une valeur multiple de {0}."),
            maxWords: $.validator.format("Veuillez fournir au plus {0} mots."),
            minWords: $.validator.format("Veuillez fournir au moins {0} mots."),
            rangeWords: $.validator.format("Veuillez fournir entre {0} et {1} mots."),
            letterswithbasicpunc: "Veuillez fournir seulement des lettres et des signes de ponctuation.",
            alphanumeric: "Veuillez fournir seulement des lettres, nombres, espaces et soulignages.",
            lettersonly: "Veuillez fournir seulement des lettres.",
            nowhitespace: "Veuillez ne pas inscrire d'espaces blancs.",
            ziprange: "Veuillez fournir un code postal entre 902xx-xxxx et 905-xx-xxxx.",
            integer: "Veuillez fournir un nombre non décimal qui est positif ou négatif.",
            vinUS: "Veuillez fournir un numéro d'identification du véhicule (VIN).",
            dateITA: "Veuillez fournir une date valide.",
            time: "Veuillez fournir une heure valide entre 00:00 et 23:59.",
            phoneUS: "Veuillez fournir un numéro de téléphone valide.",
            phoneUK: "Veuillez fournir un numéro de téléphone valide.",
            mobileUK: "Veuillez fournir un numéro de téléphone mobile valide.",
            strippedminlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
            email2: "Veuillez fournir une adresse électronique valide.",
            url2: "Veuillez fournir une adresse URL valide.",
            creditcardtypes: "Veuillez fournir un numéro de carte de crédit valide.",
            ipv4: "Veuillez fournir une adresse IP v4 valide.",
            ipv6: "Veuillez fournir une adresse IP v6 valide.",
            require_from_group: $.validator.format("Veuillez fournir au moins {0} de ces champs."),
            nifES: "Veuillez fournir un numéro NIF valide.",
            nieES: "Veuillez fournir un numéro NIE valide.",
            cifES: "Veuillez fournir un numéro CIF valide.",
            postalCodeCA: "Veuillez fournir un code postal valide.",
            pattern: "Format non valide.",
        });

        /**
         * Pour les champs tel (x-tel-input), l'élément validé est l'input hidden (il a le name).
         * Retourne l'input visible associé (dans le span suivant) ou null.
         */
        function getVisibleTelInput(element) {
            const $el = $(element);
            if ($el.attr('type') !== 'hidden') {
                return null;
            }
            const $span = $el.next('span');
            const visible = $span.find('.iti--laravel-tel-input')[0];
            return visible || null;
        }

        jQuery.validator.setDefaults({
            lang: 'fr',
            submitHandler: function (form) {
                fixIntlPhoneHiddenInput();
                form.submit();
            },
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('invalid-feedback');
                const visibleTel = getVisibleTelInput(element);
                if (visibleTel) {
                    $(element).parent().append(error);
                    error.addClass('d-block');
                } else {
                    element.closest('.form-control').parent().append(error);
                }
            },
            highlight: function (element, errorClass, validClass) {
                const visibleTel = getVisibleTelInput(element);
                if (visibleTel) {
                    $(visibleTel).addClass('is-invalid');
                } else {
                    jQuery(element).addClass('is-invalid');
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                const visibleTel = getVisibleTelInput(element);
                if (visibleTel) {
                    $(visibleTel).removeClass('is-invalid').addClass('is-valid');
                } else {
                    jQuery(element).removeClass('is-invalid').addClass('is-valid');
                }
            }
        });

        jQuery.validator.addMethod('intlPhone', function(value, element) {
            const visibleTel = getVisibleTelInput(element) || element;
            const iti = window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance(visibleTel);
            return this.optional(element) || (iti && iti.isValidNumber());
        }, 'Le numéro de téléphone est invalide');

        jQuery.validator.addMethod('alphanumeric', function(value, element) {
            return this.optional(element) || /^[a-zA-Z0-9]+$/.test(value);
        });

        jQuery.validator.addMethod('pwcheck', function (value) {
            if (value.length === 0) {
                return true;
            } // don't validate empty password fields
            return /^(.*)$/.test(value) // consists of only these
                && /[a-z]/.test(value) // has a lowercase letter
                && /\d/.test(value) // has a digit
                && value.length >= 8
        });


        window.validator = formvalidator.validate({
            ignore: '.bootstrap-duallistbox-container .filter, .bootstrap-duallistbox-container select',
            submitHandler: function (form) {

                fixIntlPhoneHiddenInput();

                form.submit();
            }
        });

        formvalidator.on('submit', function () {
            fixIntlPhoneHiddenInput();
        });
    };

    const fixIntlPhoneHiddenInput = () => {
        let intTelInputs= $('.iti--laravel-tel-input');
        if (intTelInputs.length > 0) {
            intTelInputs.each(function () {
                let iti = window.intlTelInputGlobals.getInstance(this);
                let hiddenInputId = $(this).attr('data-phone-input-name');
                $('#' + hiddenInputId).val(iti.getNumber());
            });
        }
    };

    $(function () {
        handleValidation();
    });
})($);
